import { BaseItemTypes } from '@/components/dnd/ItemTypes';
import { PaginationProps } from '@/models/base/common.selector';
import { AnalyticsReportElementScaleV2, AnalyticsV2ElementType } from '@/models/etc/types';
import { AnalyticsChartIdentity, AnalyticsChartResultBase, AnalyticsElementKind } from '@/models/interfaces/entity-settings/charts/charts';
import { ColumnSend, ColumnSendSelectable, ColumnSendWithOptions } from '@/models/interfaces/entity-settings/columns/columns';
import { AnalyticsResultTableExtended } from '@/models/interfaces/entity-settings/querytable/querytable';
import { AnalyticsList, ProjectionLeaf, SelectionRoot } from '@/models/interfaces/general.analytics.list';


export function getIdentityKind(el: BaseListItem): AnalyticsElementKind | undefined {
  if (el.elType === BaseItemTypes.FOLDER) return undefined;
  return el.elType === 0 ? AnalyticsElementKind.Selection : (el.elType === 1 ? AnalyticsElementKind.Projection : AnalyticsElementKind.List)
}
/**
 * Surrogate item types containing basic types from Backend along with fields needed for this app
 */
export interface BaseListItem extends SelectionRoot, ProjectionLeaf, AnalyticsList {
  isExpanded: boolean;
  isEditing: boolean;
  isSelected: boolean;
  isShowingMenu: boolean;
  isProcessing: boolean;
  isDeleting: boolean;
  // Прогрессивная загрузка: true пока подгружаем дочерние элементы отчёта.
  isLoadingChildren?: boolean;

  CombinedName: string;
  parent: BaseListItem;
  ChildReportElements: BaseListItem[];
  elType: BaseItemTypes;
  ElementId: number;
  ElementScale: AnalyticsReportElementScaleV2;

  FolderId?: number;
  FolderChildren?: BaseListItem[];

  _searchVisible?: boolean;
  _searchTokens?: string[] | null;
}

export interface QueryResultItem {
  elementType: BaseItemTypes;
  elementItem?: BaseListItem;
  elementGraphItem?: AnalyticsChartIdentity;
  elementSegmentType: AnalyticsV2ElementType;
  Element?: AnalyticsResultTableExtended | AnalyticsChartResultBase;
  pagination?: PaginationProps;
  selectedAll?: string;
  selectedEntities?: number[];
  unselectedEntities?: number[];
}

export interface ColumnListItem extends ColumnSend, ColumnSendSelectable, ColumnSendWithOptions
{
    // recursive id. ColumnSend items don't have any id's so this field is needed to
    // find corresponding items between selectedList and original recursive structure
    compound_id: string;
    // recursive name, e.g. RootName.Child1Name.Child2.Name etc.
    compound_name: string;
    IdChain: number[];
}

export interface ColumnGroupItem extends ColumnListItem
{
    // If group_id is not null then it means that these items should be inside this one item.
    // In this case recursively go through items and increment position
    // group id
    group_id: number | null;
    // indication that item will be grouped soon - show in css
    going_to_group: boolean;
    
    // sub-items
    sub_items?: ColumnListItem[] | null;
}